import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { getFeatureFlags } from "../../services/api.service.js";
import { FeatureFlagsContext } from "./feature-flags.context.js";

const REFRESH_INTERVAL_MS = 3_600_000; // 1 hour

interface FeatureFlagsProviderProps {
  children: React.ReactNode;
}

export const FeatureFlagsProvider = ({
  children,
}: FeatureFlagsProviderProps) => {
  const { data: featureFlags } = useQuery({
    queryFn: getFeatureFlags,
    queryKey: ["getFeatureFlags"],
    staleTime: REFRESH_INTERVAL_MS,
  });

  const state = useMemo(
    () => ({
      flags: featureFlags ?? {},
    }),
    [featureFlags]
  );

  return (
    <FeatureFlagsContext.Provider value={state}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
